import { render, staticRenderFns } from "./AdminDrawer.vue?vue&type=template&id=82c8e9a0&"
import script from "./AdminDrawer.vue?vue&type=script&lang=js&"
export * from "./AdminDrawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports